import React, {useState} from "react";
import MicroModal from "./MicroModal.js";

export default function Modal(props) {

  const ariaHidden = props.open === true ? "false" : "true";

  const [modalClasses, setModalClasses] = useState("gc__modal gc__micromodal-slide");

  setTimeout(() => {

    if (props.open === true) {
      setModalClasses("gc__modal gc__micromodal-slide is_open");
    } else {
      setModalClasses("gc__modal gc__micromodal-slide");
    }

  }, 100);

  return (
    <div className={modalClasses} id={props.id} aria-hidden={ariaHidden} aria-label={props.title}>
      <div onClick={props.onClose} className="gc__modal_overlay" tabIndex="-1" data-micromodal-close></div>
      <div className="gc__modal_container" role="dialog" aria-modal="true" aria-labelledby={props.id}>
        {props.open === true ? props.children : <></>}
      </div>
    </div>
  )
}
